module.exports = __webpack_public_path__ + "img/verifikasi_phone.a2032223.svg";